<template>
    <v-container>
        <v-row class="contentRow">
            <v-col cols="12">
                <h1 class="mb-2 font-weight-black darkColor--text ">Received Transactions</h1>
				<p class="mb-5 font-weight-medium darkColor--text text-center">This is an overview of the transactions you have received.</p>
			</v-col>
            <v-tabs background-color="transparent" light centered icons-and-text>
                <v-tab>
                    Recent
                    <v-icon>fas fa-history</v-icon>
                </v-tab>
                <v-tab>
                    Unconfirmed
                    <v-icon>fas fa-ellipsis-h</v-icon>
                </v-tab>
                <v-tab>
                    Archive
                    <v-icon>fa-archive</v-icon>
                </v-tab>
                <v-tab-item>
                    <br />
                    <v-card background-color="transparent" elevation="0" outlined>
                        <v-card-title class="text-center justify-left py-6">
                            <h3 class="darkColor--text">Recent Transactions</h3>
                        </v-card-title>
                        <v-data-table
                                :loading="recentOptions.loading"
                                theme--
                                light
                                :headers="headers"
                                :items="recentOptions.data"
                                :items-per-page="recentOptions.limit"
                                :server-items-length="recentOptions.total"
                                :options.sync="recentOptions.options"
                                class="light table mx-4 assessed-table"
								:footer-props="{
						'items-per-page-options': [5, 10, 15]
					}"
                        >
                            <template v-slot:item.id="{ item }">
                                <router-link :to="{name: `Transaction Details`, params: {id: item.id}}" >{{item.id}}</router-link>
                            </template>
                            <template v-slot:item.timestamp="{ item }">
                                {{  item.timestamp | moment("DD.MM.YYYY  h:mm:ss") }}
                            </template>
                            <template v-slot:item.status="{ item }">
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <p class="mx-2 my-0" :style="{ color: item.status.color}" v-bind="attrs" v-on="on">
                                            <v-icon  small :style="{ color: item.status.color}">fas fa-{{ item.status.icon}}</v-icon>
                                            {{item.status.description_short}}
                                        </p>
                                    </template>
                                    <span>{{item.status.description_long}}</span>
                                </v-tooltip>
                            </template>
                            <template v-slot:item.blockchainStatus="{ item }" >
                                <a  v-if="item.block!=='Awaiting validification'" :href="'https://nodes.orixe.tech/blocks/' + item.block" target='_blank'>Block #{{item.block}}</a>
                                <p class="my-0 text-left font-italic" v-if="item.block==='Awaiting validification'">{{item.block}}</p>
                            </template>
                        </v-data-table>

                        <br />
                    </v-card>
                </v-tab-item>
                <v-tab-item>
                    <br />
                    <v-card background-color="transparent" elevation="0" outlined>
                        <v-card-title class="text-center justify-left py-6">
                            <h3 class="darkColor--text">Unconfirmed Transactions</h3>
                        </v-card-title>
                        <v-data-table
                                :loading="unconfirmedOptions.loading"
                                theme--
                                light
                                :headers="headers"
                                :items="unconfirmedOptions.data"
                                :items-per-page="unconfirmedOptions.limit"
                                :server-items-length="unconfirmedOptions.total"
                                :options.sync="unconfirmedOptions.options"
                                class="light table mx-4 assessed-table"
								:footer-props="{
						'items-per-page-options': [5, 10, 15]
					}"
                        >
                            <template v-slot:item.id="{ item }">
                                <router-link :to="{name: `Transaction Details`, params: {id: item.id}}">{{item.id}}</router-link>
                            </template>
                            <template v-slot:item.timestamp="{ item }">
                                {{  item.timestamp | moment("DD.MM.YYYY  h:mm:ss") }}
                            </template>
                            <template v-slot:item.status="{ item }">
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <p class="mx-2 my-0" :style="{ color: item.status.color}" v-bind="attrs" v-on="on">
                                            <v-icon  small :style="{ color: item.status.color}">fas fa-{{ item.status.icon}}</v-icon>
                                            {{item.status.description_short}}
                                        </p>
                                    </template>
                                    <span>{{item.status.description_long}}</span>
                                </v-tooltip>
                            </template>
                            <template v-slot:item.blockchainStatus="{ item }" >
                                <a  v-if="item.block!=='Awaiting validification'" :href="'https://nodes.orixe.tech/blocks/' + item.block" target='_blank'>Block #{{item.block}}</a>
                                <p class="my-0 text-left font-italic" v-if="item.block==='Awaiting validification'">{{item.block}}</p>
                            </template>
                        </v-data-table>
                        <br />
                    </v-card>
                </v-tab-item>
                <v-tab-item>
                    <br />
                    <v-card background-color="transparent" elevation="0" outlined>
                        <v-card-title class="text-center justify-left py-6">
                            <h3 style="color: #2E8B57">Confirmed Transactions</h3>
                        </v-card-title>
                        <v-data-table
                                :loading="confirmedOptions.loading"
                                theme--
                                light
                                :headers="headers"
                                :items="confirmedOptions.data"
                                :items-per-page="confirmedOptions.limit"
                                :server-items-length="confirmedOptions.total"
                                :options.sync="confirmedOptions.options"
                                class="light table mx-4 assessed-table"
								:footer-props="{
						'items-per-page-options': [5, 10, 15]
					}"
                        >
                            <template v-slot:item.id="{ item }">
                                <router-link :to="{name: `Transaction Details`, params: {id: item.id}}">{{item.id}}</router-link>
                            </template>
                            <template v-slot:item.timestamp="{ item }">
                                {{  item.timestamp | moment("DD.MM.YYYY  h:mm:ss") }}
                            </template>
                            <template v-slot:item.status="{ item }">
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <p class="mx-2 my-0" :style="{ color: item.status.color}" v-bind="attrs" v-on="on">
                                            <v-icon  small :style="{ color: item.status.color}">fas fa-{{ item.status.icon}}</v-icon>
                                            {{item.status.description_short}}
                                        </p>
                                    </template>
                                    <span>{{item.status.description_long}}</span>
                                </v-tooltip>
                            </template>
                            <template v-slot:item.blockchainStatus="{ item }" >
                                <a  v-if="item.block!=='Awaiting validification'" :href="'https://nodes.orixe.tech/blocks/' + item.block" target='_blank'>Block #{{item.block}}</a>
                                <p class="my-0 text-left font-italic" v-if="item.block==='Awaiting validification'">{{item.block}}</p>
                            </template>
                        </v-data-table>
                        <br />
                    </v-card>
                    <br />
                    <v-card background-color="transparent" elevation="0" outlined>
                        <v-card-title class="text-center justify-left py-6">
                            <h3 style="color: #B22222">Invalid Transactions</h3>
                        </v-card-title>
                        <v-data-table
                                :loading="invalidOptions.loading"
                                theme--
                                light
                                :headers="headers"
                                :items="invalidOptions.data"
                                :items-per-page="invalidOptions.limit"
                                :server-items-length="invalidOptions.total"
                                :options.sync="invalidOptions.options"
                                class="light table mx-4 assessed-table"
								:footer-props="{
						'items-per-page-options': [5, 10, 15]
					}"
                        >
                            <template v-slot:item.id="{ item }">
                                <router-link :to="{name: `Transaction Details`, params: {id: item.id}}">{{item.id}}</router-link>
                            </template>
                            <template v-slot:item.timestamp="{ item }">
                                {{  item.timestamp | moment("DD.MM.YYYY  h:mm:ss") }}
                            </template>
                            <template v-slot:item.status="{ item }">
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <p class="mx-2 my-0" :style="{ color: item.status.color}" v-bind="attrs" v-on="on">
                                            <v-icon  small :style="{ color: item.status.color}">fas fa-{{ item.status.icon}}</v-icon>
                                            {{item.status.description_short}}
                                        </p>
                                    </template>
                                    <span>{{item.status.description_long}}</span>
                                </v-tooltip>
                            </template>
                            <template v-slot:item.blockchainStatus="{ item }" >
                                <a  v-if="item.block!=='Awaiting validification'" :href="'https://nodes.orixe.tech/blocks/' + item.block" target='_blank'>Block #{{item.block}}</a>
                                <p class="my-0 text-left font-italic" v-if="item.block==='Awaiting validification'">{{item.block}}</p>
                            </template>
                        </v-data-table>
                        <br />
                    </v-card>
                </v-tab-item>
            </v-tabs>
        </v-row>
    </v-container>
</template>

<script>
import TransactionAPI from "../../api/trace/transaction"
import LoadingState from "../../consts/LoadingState"
import TransactionStatus from "../../consts/TransactionStatus"
export default {
	name: "RecipientView",

	data() {
		return {
			recentOptions:{
				limit:5,
				offset:0,
				total:0,
				data:[],
				loading:true,
				options: {},
			},
			unconfirmedOptions:{
				limit:5,
				offset:0,
				total:0,
				data:[],
				filter:[TransactionStatus.PENDING,TransactionStatus.REQUESTED_EDIT],
				loading:true,
				options: {},
			},
			confirmedOptions:{
				limit:5,
				offset:0,
				total:0,
				data:[],
				filter:[TransactionStatus.CONFIRMED],
				loading:true,
				options: {},
			},
			invalidOptions:{
				limit:5,
				offset:0,
				total:0,
				data:[],
				filter:[
					TransactionStatus.REJECTED,TransactionStatus.INVALID,TransactionStatus.CANCELLED,TransactionStatus.RESCINDED,
					TransactionStatus.EDITED,TransactionStatus.INHERITED_ERROR
				],
				loading:true,
				options: {},
			},
			headers: [
				{
					text: "Transaction ID",
					align: "start",
					sortable: false,
					value: "id",
					class: "secondary--text"
				},
				{
					text: "Timestamp",
					value: "timestamp",
					sortable: false,
					class: "secondary--text"
				},
				{
					text: "Recipient Order Number",
					value: "recipientordernumber",
					sortable: false,
					class: "secondary--text"
				},
				{
					text: "Sender",
					value: "sender",
					sortable: false,
					class: "secondary--text"
				},
				{
					text: "Status",
					value: "status",
					sortable: false,
					class: "secondary--text"
				},
				{
					text: "Blockchain Status",
					value: "blockchainStatus",
					sortable: false,
					class: "secondary--text"
				}
			],
			draftHeaders:[
				{
					text: "Draft ID",
					align: "start",
					sortable: false,
					value: "ID",
					class: "secondary--text"
				},
				{
					text: "Timestamp",
					value: "Timestamp",
					sortable: false,
					class: "secondary--text"
				},
				{
					text: "Delete",
					value: "delete",
					sortable: false,
					class: "secondary--text"
				}
			],
			deleteDialog:false,
			selectedDraftID:null,
		}
	},
	mounted() {
		this.getRecentTransaction()
		this.getUnconfirmedTransaction()
		this.getConfirmedTransaction()
		this.getInvalidTransaction()
	},
	watch: {
		"recentOptions.options": {
			handler () {
				//if user select all
				if (this.recentOptions.options.itemsPerPage===-1){
					this.recentOptions.options.itemsPerPage=this.recentOptions.total
				}
				this.recentOptions.offset=(this.recentOptions.options?.page-1) * this.recentOptions.options?.itemsPerPage
				this.recentOptions.limit=this.recentOptions.options?.itemsPerPage
				this.getRecentTransaction()
			},
			deep: true,
		},
		"unconfirmedOptions.options": {
			handler () {
				//if user select all
				if (this.unconfirmedOptions.options.itemsPerPage===-1){
					this.unconfirmedOptions.options.itemsPerPage=this.unconfirmedOptions.total
				}
				this.unconfirmedOptions.offset=(this.unconfirmedOptions.options?.page-1) * this.unconfirmedOptions.options?.itemsPerPage
				this.unconfirmedOptions.limit=this.unconfirmedOptions.options?.itemsPerPage
				this.getUnconfirmedTransaction()
			},
			deep: true,
		},
		"confirmedOptions.options": {
			handler () {
				if (this.confirmedOptions.options.itemsPerPage===-1){
					this.confirmedOptions.options.itemsPerPage=this.confirmedOptions.total
				}
				this.confirmedOptions.offset=(this.confirmedOptions.options?.page-1) * this.confirmedOptions.options?.itemsPerPage
				this.confirmedOptions.limit=this.confirmedOptions.options?.itemsPerPage
				this.getConfirmedTransaction()
			},
			deep: true,
		},
		"invalidOptions.options": {
			handler () {
				if (this.invalidOptions.options.itemsPerPage===-1){
					this.invalidOptions.options.itemsPerPage=this.invalidOptions.total
				}
				this.invalidOptions.offset=(this.invalidOptions.options?.page-1) * this.invalidOptions.options?.itemsPerPage
				this.invalidOptions.limit=this.invalidOptions.options?.itemsPerPage
				this.getInvalidTransaction()
			},
			deep: true,
		},
		"draftOptions.options": {
			handler () {
				if (this.draftOptions.options.itemsPerPage===-1){
					this.draftOptions.options.itemsPerPage=this.draftOptions.total
				}
				this.draftOptions.offset=(this.draftOptions.options?.page-1) * this.draftOptions.options?.itemsPerPage
				this.draftOptions.limit=this.draftOptions.options?.itemsPerPage
				this.getDrafts()
			},
			deep: true,
		},
	},
	methods: {
		getRecentTransaction(){
			this.recentOptions.loading=true
			TransactionAPI.getTransactionList(this.recentOptions.limit,this.recentOptions.offset, 2)
				.then(data => {
					this.recentOptions.total=data?.metadata?.pagination?.totalRecords
					this.recentOptions.data=data?.data
					this.recentOptions.loading=false
				})
				.catch(error => {
					this.recentOptions.loading=false
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
		getUnconfirmedTransaction(){
			this.unconfirmedOptions.loading=true
			TransactionAPI.getFilteredTransactionList(this.unconfirmedOptions.limit,this.unconfirmedOptions.offset, this.unconfirmedOptions.filter,2)
				.then(data => {
					this.unconfirmedOptions.total=data?.metadata?.pagination?.totalRecords
					this.unconfirmedOptions.data=data?.data
					this.unconfirmedOptions.loading=false
				})
				.catch(error => {
					this.recentOptions.loading=false
					this.unconfirmedOptions.loading=false
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
		getConfirmedTransaction(){
			this.confirmedOptions.loading=true
			TransactionAPI.getFilteredTransactionList(this.confirmedOptions.limit,this.confirmedOptions.offset, this.confirmedOptions.filter,2)
				.then(data => {
					this.confirmedOptions.total=data?.metadata?.pagination?.totalRecords
					this.confirmedOptions.data=data?.data
					this.confirmedOptions.loading=false
				})
				.catch(error => {
					this.recentOptions.loading=false
					this.confirmedOptions.loading=false
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
		getInvalidTransaction(){
			this.invalidOptions.loading=true
			TransactionAPI.getFilteredTransactionList(this.invalidOptions.limit,this.invalidOptions.offset, this.invalidOptions.filter,2)
				.then(data => {
					this.invalidOptions.total=data?.metadata?.pagination?.totalRecords
					this.invalidOptions.data=data?.data
					this.invalidOptions.loading=false
				})
				.catch(error => {
					this.recentOptions.loading=false
					this.invalidOptions.loading=false
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
	}
}
</script>
